<div>
  <div style="z-index: -100;" class="bgSlider">

    <!-- <app-slider [language]="rootModel.language" [sliderClass]="''"></app-slider> -->

  </div>


  <div class="container">
    <div class="row d-none d-lg-block d-xl-none d-none d-xl-block " >
      <app-slider [language]="rootModel.language" [sliderClass]="'carouselPosition'"></app-slider>
    </div>
  </div>
  <div class="row" style="margin-top: 25px;">
    <div class="col-lg-6">

    </div>
    <div class="col-lg-1">
      <a class="d-none d-lg-block d-xl-none d-none d-xl-block"  href="#slidercarouselPosition" role="button"      data-slide="prev">
        <img src="../../../assets/genel/sliderSol.png" style="border-image: 10px;" alt="" width="60" height="auto">
        <span class="sr-only">Previous</span>
      </a>
          <!-- <a class="carousel-control-prev"  href="#slidercarouselPosition" role="button"     data-slide="prev">
        <a class="carousel-control-prev"  href="#slider" role="button"      data-slide="prev">
          <img src="../../../assets/genel/sliderSol.png" style="border-image: 10px;" alt="" width="40" height="auto">
          <span class="sr-only">Previous</span>
        </a>
  
      </a> -->

    </div>
    <div class="col-lg-2" >
     

    </div>
    <div class="col-lg-1 ">

      <a class="d-none d-lg-block d-xl-none d-none d-xl-block" href="#slidercarouselPosition" role="button" data-slide="next">
        <img src="../../../assets/genel/sliderSag.png" alt="" width="60" height="auto">
        <span class="sr-only">Next</span>
       </a>

    </div> 

  </div>

  <div class="row mt-3">

    <div class="col-lg-3 d-none d-lg-block d-xl-none d-none d-xl-block" style="margin-left: 30px;">
      <img src="../../../assets/genel/dSanatLogo.png" style="max-width: 450px;" alt="kapak">
      <br>
    </div>
    <div class="col-lg-1"></div>
    <div class="col-lg-7 p-3 text-justify">

      <router-outlet></router-outlet>
    </div>

  </div>
</div>
